import incomeImg from '../../assets/Entradas.svg';
import outcomeImg from '../../assets/Saídas.svg';
import totalImg from '../../assets/Total.svg';
import { useTransactions } from '../../hooks/useTransactions';
import { Container } from "./styles";

export function Summary() {
    const { transactions } = useTransactions();
    const todayDay = (new Date().getDay() - 1).toString();
    const todayMonth = (new Date().getMonth() + 1).toString();

    const summary = transactions.reduce((acc, transaction) => {
        const transactionDay = (new Date(transaction.transactionDate).getDay()).toString();
        const transactionMonth = (new Date(transaction.transactionDate).getMonth() + 1).toString();

        if (transaction.type === 'deposit') {
            console.log('transacao', { dia: transactionDay, mes: transactionMonth }, { hojedia: todayDay, hojemes: todayMonth })

            acc.deposits += transaction.amount;
            acc.total += transaction.amount;
            if (transactionDay === todayDay && todayMonth === transactionMonth) {
                acc.day_deposits += transaction.amount;
                acc.day_total += transaction.amount;
            }
        } else {
            acc.withdraws += transaction.amount;
            acc.total -= transaction.amount;
            if (transactionDay === todayDay && todayMonth === transactionMonth) {
                acc.day_withdraws += transaction.amount;
                acc.day_total -= transaction.amount;
            }
        }

        return acc;
    }, {
        deposits: 0,
        withdraws: 0,
        total: 0,
        day_deposits: 0,
        day_withdraws: 0,
        day_total: 0
    })

    return (
        <Container>
            <div>
                <header>
                    <p>Entradas</p>
                    <img src={incomeImg} alt="Entradas" />
                </header>
                <strong>
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(Number(summary.deposits))}
                </strong>
                <p>Hoje: </p>
                <strong>
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(Number(summary.day_deposits))}
                </strong>
            </div>


            <div>
                <header>
                    <p>Saídas</p>
                    <img src={outcomeImg} alt="Entradas" />
                </header>
                <strong>
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(Number(summary.withdraws))}
                </strong>
                <p>Hoje: </p>
                <strong>
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(Number(summary.day_withdraws))}
                </strong>
            </div>

            <div className="highlight-background">
                <header>
                    <p>Total</p>
                    <img src={totalImg} alt="Entradas" />
                </header>
                <strong>
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(Number(summary.total))}
                </strong>
                <p>Hoje: </p>
                <strong>
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(Number(summary.day_total))}
                </strong>
            </div>
        </Container>
    );
}